import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * SiteFooter — quiet credit line shown at the bottom of dashboard pages.
 *
 * Drop it into a flex-column layout (`SidebarInset`, `AppShell`, etc.) so it
 * sits below the main content. Hidden when printing.
 */
export function SiteFooter({ className, ...props }: React.HTMLAttributes<HTMLElement>) {
  return (
    <footer
      className={cn(
        "w-full px-5 py-6 text-center text-xs text-muted-foreground print:hidden",
        className,
      )}
      {...props}
    >
      <span>
        Made by{" "}
        <a
          href="https://holymoly.dev"
          target="_blank"
          rel="noopener noreferrer"
          className="underline decoration-muted-foreground/40 underline-offset-2 transition-colors hover:text-foreground hover:decoration-foreground"
        >
          Holy Moly
        </a>
      </span>
    </footer>
  );
}
